(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("babel-runtime/helpers/typeof"), require("leaflet"), require("leaflet.gridlayer.googlemutant"), require("vue2-leaflet"));
	else if(typeof define === 'function' && define.amd)
		define(["babel-runtime/helpers/typeof", "leaflet", "leaflet.gridlayer.googlemutant", "vue2-leaflet"], factory);
	else if(typeof exports === 'object')
		exports["Vue2LeafletGoogleMutant"] = factory(require("babel-runtime/helpers/typeof"), require("leaflet"), require("leaflet.gridlayer.googlemutant"), require("vue2-leaflet"));
	else
		root["Vue2LeafletGoogleMutant"] = factory(root["babel-runtime/helpers/typeof"], root["leaflet"], root["leaflet.gridlayer.googlemutant"], root["vue2-leaflet"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_6__, __WEBPACK_EXTERNAL_MODULE_7__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1),
  /* template */
  __webpack_require__(3),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof2 = __webpack_require__(4);

var _typeof3 = _interopRequireDefault(_typeof2);

var _leaflet = __webpack_require__(5);

var _leaflet2 = _interopRequireDefault(_leaflet);

__webpack_require__(6);

var _vue2Leaflet = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var props = {
  options: {
    type: Object,
    default: function _default() {
      return {};
    }
  },
  apikey: {
    type: String,
    default: function _default() {
      return '';
    }
  },
  lang: {
    type: String,
    default: null
  },
  region: {
    type: String,
    default: null
  },
  name: {
    type: String,
    default: ''
  },
  layerType: {
    type: String,
    default: 'base'
  },
  visible: {
    type: Boolean,
    default: true
  }
};

exports.default = {
  props: props,
  data: function data() {
    return {
      ready: false
    };
  },
  mounted: function mounted() {
    this.mapObject = _leaflet2.default.gridLayer.googleMutant(this.options);
    _leaflet2.default.DomEvent.on(this.mapObject, this.$listeners);
    (0, _vue2Leaflet.propsBinder)(this, this.mapObject, props);

    if (!((typeof google === 'undefined' ? 'undefined' : (0, _typeof3.default)(google)) === 'object' && (0, _typeof3.default)(google.maps) === 'object')) {
      var googleapisscript = document.createElement('script');
      var scriptUrl = 'https://maps.googleapis.com/maps/api/js?key=' + this.apikey;

      scriptUrl += this.lang ? '&language=' + this.lang : '';
      scriptUrl += this.region ? '&region=' + this.region : '';

      googleapisscript.setAttribute('src', scriptUrl);
      document.head.appendChild(googleapisscript);
    }

    this.ready = true;
    this.parentContainer = (0, _vue2Leaflet.findRealParent)(this.$parent);
    this.parentContainer.addLayer(this, !this.visible);
  },
  beforeDestroy: function beforeDestroy() {
    this.parentContainer.removeLayer(this);
  },

  methods: {
    addLayer: function addLayer(layer, alreadyAdded) {
      if (!alreadyAdded) {
        this.mapObject.addLayer(layer.mapObject);
      }
    },
    removeLayer: function removeLayer(layer, alreadyRemoved) {
      if (!alreadyRemoved) {
        this.mapObject.removeLayer(layer.mapObject);
      }
    }
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = options.computed || (options.computed = {})
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.ready) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("babel-runtime/helpers/typeof");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("leaflet");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("leaflet.gridlayer.googlemutant");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("vue2-leaflet");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// Vue2LeafletGoogleMutant.js